import React from "react";
import PropTypes from "prop-types";
import Dropzone from "react-dropzone";
import { Row } from "react-flexbox-grid";
import { CircularProgress, Card } from "@material-ui/core";

const styles = {
  dropzone: {
    height: 400,
    marginTop: 20,
    marginBottom: 20,
    borderStyle: "dashed",
    textAlign: "center",
    borderRadius: 2
  },
  dropzoneText: {
    height: "100%",
    fontSize: 28,
    color: "gray",
    fontFamily: "roboto"
  },
  active: {
    borderStyle: "solid"
  },
  filedrop: {
    padding: 20
  }
};

const FileDropCard = props => (
  <Card style={styles.filedrop}>
    <Dropzone
      onDrop={props.soloOnFilesDrop}
      style={styles.dropzone}
      activeStyle={styles.active}
    >
      <Row center="xs" middle="xs" style={styles.dropzoneText}>
        {props.soloFilesUploading ? (
          <CircularProgress />
        ) : (
          <div>
            <div>
              Drop RBR Solo <small>(eng.txt or .rsk)</small>
            </div>
            <div>files here to upload them.</div>
          </div>
        )}
      </Row>
    </Dropzone>
  </Card>
);

FileDropCard.propTypes = {
  soloOnFilesDrop: PropTypes.func.isRequired,
  soloFilesUploading: PropTypes.bool.isRequired
};

export default FileDropCard;
